import PropTypes from 'prop-types';

import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

const FileColumnsTable = ({ 
  rows, handleEdit, handleDelete, excludeKeys 
}) => {
  const heading = ['SI No', 'Column Name', 'Edit', 'Delete'];
  return(
    <TableContainer component={Paper} sx={{ margin: 'auto' }}>
      <Table sx={{ minWidth: 650 }} aria-label="Table">
      <TableHead>
          <TableRow>
            {heading.map((title, index) => (
              <TableCell align="center" key={index}>{title}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow
              key={index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell align="center">{index + 1}</TableCell>
              {Object.keys(row).map((key, rowIndex) => (
                (!excludeKeys.includes(key) && <TableCell align="center" key={rowIndex}>{row[key]}</TableCell>)
              ))}

              <TableCell align="center">
                <EditOutlinedIcon 
                  sx={{ cursor: 'pointer' }} 
                  onClick={() => handleEdit(row.id, row.file_column)}
                />
              </TableCell>
              <TableCell align="center">
                <DeleteOutlinedIcon 
                  sx={{ cursor: 'pointer' }} 
                  onClick={() => handleDelete(row.id)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
};

FileColumnsTable.propTypes = {
  rows: PropTypes.array.isRequired,
  handleEdit: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  excludeKeys: PropTypes.array.isRequired,
};

export default FileColumnsTable;